const prodUrls = [
    'app.shoutbase.com',
    'app.shoutbase.com.s3-website-us-east-1.amazonaws.com',
    'd8079pc0rmhq4.cloudfront.net',
]

export const isProd = typeof(window) !== 'undefined' ? prodUrls.includes(window.location.hostname) : false
export const isDev = typeof(window) === 'undefined' || window.location.hostname === 'localhost'
export const googleAnalyticsKey = process.env.REACT_APP_SHOUTBASE_GA_KEY || ""


// WEBPACK FOOTER //
// ./src/config.js